import type * as SchemaTypes from '../types';

import { gql } from '@apollo/client';
export type AvailableModulesDataFragment = (
  { __typename: 'AvailableModules' }
  & Pick<SchemaTypes.AvailableModules, 'hasApplicationModules' | 'hasConfiguratorModules' | 'hasCustomerModules' | 'hasVehicleManagementModules' | 'hasFinderVehicleManagementModules' | 'hasPromotionCodeModules' | 'hasInventories' | 'hasEventModules' | 'hasAgreementModules' | 'hasFinanceProducts' | 'hasPaymentModules' | 'hasBanks' | 'hasSystemBanks' | 'hasInsuranceModules' | 'hasLabelsModules' | 'hasMobilityModules' | 'hasWebsiteModules' | 'hasCtsModules' | 'hasAudiCalculationModules' | 'hasPorscheMasterDataModules' | 'hasConsentModules' | 'hasCapModules' | 'hasAppointmentModules' | 'hasAutoplayModules' | 'hasTradeInModules' | 'hasGiftVoucherModules'>
);

export const AvailableModulesDataFragmentDoc = /*#__PURE__*/ gql`
    fragment AvailableModulesData on AvailableModules {
  hasApplicationModules
  hasConfiguratorModules
  hasCustomerModules
  hasVehicleManagementModules
  hasFinderVehicleManagementModules
  hasPromotionCodeModules
  hasInventories
  hasEventModules
  hasAgreementModules
  hasFinanceProducts
  hasPaymentModules
  hasBanks
  hasSystemBanks
  hasInsuranceModules
  hasLabelsModules
  hasMobilityModules
  hasWebsiteModules
  hasCtsModules
  hasAudiCalculationModules
  hasPorscheMasterDataModules
  hasConsentModules
  hasCapModules
  hasAppointmentModules
  hasAutoplayModules
  hasTradeInModules
  hasGiftVoucherModules
}
    `;